export const pt_BR = {
    LEFT: 'Esquerda: Mover para o dia anterior.',
    RIGHT: 'Para a direita: Mover para o próximo dia.',
    DOWN: 'Para baixo: Mover para a próxima linha.',
    UP: 'Até: Mover para a linha anterior.',
    PGUP: 'PgUp: Mover para o mês anterior.',
    PGDOWN: 'PgDown: Move para o próximo mês.',
    HOME: 'Home: Move para o ano anterior.',
    END: 'End: Move para o próximo ano.',
    ESC: 'Esc/Hoje/fechar: Fechar o calendário.',
    TITLE: 'As Instruções De Teclado'
};
